<template>
  <div class="container">
    <b-modal id="login-confirm-modal" :no-close-on-backdrop="true" title="同時ログイン制限" @ok="handleLoginConfirmModalOk">
      <p>他のタブやウインドウで別のユーザがログイン済みのため<br>ログイン操作をキャンセルしました。</p>
      <p>本ダイアログのOKボタンを選択することで<br>他のタブやウインドウのユーザを強制ログアウトできます。</p>
    </b-modal>
    <div class="card mx-auto col-8">
      <article class="card-body">
        <Title title="SecHack365 修了生ポータルサービス ログイン" description="運営者アカウントのメールアドレスとパスワードを入力してください" />
        <validation-observer ref="loginForm">
          <form>
            <b-form-group>
              <validation-provider name="メールアドレス" rules="required|email" v-slot="validationContext">
                <b-input-group>
                  <div class="input-group-prepend">
                    <span class="input-group-text"><b-icon-envelope></b-icon-envelope></span>
                  </div>
                  <b-form-input
                    name="メールアドレス"
                    type="email"
                    placeholder="メールアドレス"
                    :state="getValidationState(validationContext)"
                    v-model="email"
                    @keydown.enter.native="onKeydownEnter($event.keyCode)"
                    aria-describedby="email-feedback"
                  />
                  <b-form-invalid-feedback id="email-feedback">
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-input-group>
              </validation-provider>
            </b-form-group>
            <b-form-group>
              <validation-provider name="パスワード" rules="required" v-slot="validationContext">
                <b-input-group>
                  <div class="input-group-prepend">
                    <span class="input-group-text"><b-icon-lock></b-icon-lock></span>
                  </div>
                  <b-form-input
                    name="パスワード"
                    type="password"
                    placeholder="パスワード"
                    :state="getValidationState(validationContext)"
                    v-model="password"
                    @keydown.enter.native="onKeydownEnter($event.keyCode)"
                    aria-describedby="password-feedback"
                  />
                  <b-form-invalid-feedback id="password-feedback">
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-input-group>
              </validation-provider>
            </b-form-group>
            <b-form-group>
              <b-button block variant="default" @click="signIn" class="mx-auto col-md-4">ログイン</b-button>
            </b-form-group>
            <!--
          <p class="text-center"><a href="#" class="btn">Forgot password?</a></p>
          --></form>
        </validation-observer>
        <router-link class="" to="/terms" target="_blank">利用規約</router-link>
        <div>ログインすると、利用規約と以下の内容に同意したものとみなします。</div>
      </article>
    </div>
    <div class="card mx-auto col-8 mt-2" style="position:relative; height:150px; overflow-y:scroll;">
      <article class="card-body">
        <div>【登録した情報の取り扱い】</div>
        <ul>
          <li>登録した情報はNICTのみが内容を確認して、SecHack365の運営のためにのみ利用します。</li>
          <li>登録した情報を勝手に公開する事はありません。</li>
          <li>登録した情報は修了生の活動の様子の把握のため、個人が特定できないような処理や集計を施した上で、NICT内での報告等に利用させてもらいます。</li>
          <li>顕著な成果があった場合には、NICTからヒアリングをさせてもらう場合があります。</li>
          <li>NICTにて、個別の成果を報告などで取り上げたい場合には、成果の登録者への予めの相談と承認を得た上で実施します。</li>
        </ul>
      </article>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Title from '@/components/Title.vue'
export default {
  name: 'Login',
  components: {
    Title
  },
  data: function () {
    return {
      email: '',
      password: ''
    }
  },
  computed: {
    ...mapState({
      emailValidMessage: (state) => state.auth.validations.email,
      passwordValidMessage: (state) => state.auth.validations.password
    })
  },
  methods: {
    async handleLoginConfirmModalOk () {
      // 他のタブやウインドウを強制ログアウト
      localStorage.setItem('logout', new Date().getTime())
      // await new Promise(resolve => setTimeout(resolve, 3000))
    },

    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null
    },

    async signIn() {
      const isValid = await this.$refs.loginForm.validate()
      if (!isValid) {
        return
      }

      try {
        await this.$store.dispatch('auth/login', {
          email: this.email,
          password: this.password,
          adminStatus: 1
        })
      } catch (rejectData) {
        // 同時ログイン時
        if (rejectData.status === 409) {
          this.$bvModal.show('login-confirm-modal')
        }
        this.$root.$bvToast.toast(rejectData.data.validations.email, {
          variant: 'danger',
          toaster: 'b-toaster-top-center',
          autoHideDelay: 3000
        })
      }
    },

    onKeydownEnter(keyCode) {
      if (Number(keyCode) === 13) {
        this.signIn()
      }
    }
  }
}
</script>
